let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("02YkI")).then(() => parcelRequire('6XXyt'));